(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matrix-shop"] && !Shopify.designMode) return;
  try {
    
  function initMatrixShop(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const panel = root.querySelector('.ms-filter-panel');
    const media = matchMedia('(max-width: 989px)');
    const setPanel = () => { panel.open = !media.matches; };
    setPanel();
    media.addEventListener('change', setPanel);
    root.querySelector('[data-sort]').addEventListener('change', event => event.target.form.requestSubmit());
    root.querySelectorAll('[data-show-more]').forEach(button => button.addEventListener('click', () => {
      const expanded = button.closest('.ms-filter-values').classList.toggle('ms-expanded');
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? button.dataset.less : button.dataset.more;
    }));
    const storageKey = 'matrix-saved-products';
    let saved = [];
    try { const value = JSON.parse(localStorage.getItem(storageKey) || '[]'); if (Array.isArray(value)) saved = value.filter(item => typeof item.id === 'string' && typeof item.title === 'string' && typeof item.url === 'string' && item.url.startsWith('/products/')).slice(0,200); } catch {}
    const dialog = root.querySelector('[data-saved-dialog]');
    const refreshSaved = () => {
      root.querySelectorAll('[data-save-product]').forEach(button => button.setAttribute('aria-pressed', String(saved.some(item => item.id === button.dataset.id))));
      const list = root.querySelector('[data-saved-list]');
      list.replaceChildren();
      saved.forEach(item => { const li = document.createElement('li'); const a = document.createElement('a'); a.href = item.url; a.textContent = item.title; li.append(a); list.append(li); });
      root.querySelector('[data-saved-empty]').hidden = saved.length > 0;
    };
    root.querySelectorAll('[data-save-product]').forEach(button => button.addEventListener('click', () => {
      const id = button.dataset.id;
      if (saved.some(item => item.id === id)) saved = saved.filter(item => item.id !== id);
      else saved.push({id, title:button.dataset.title, url:button.dataset.url});
      try { localStorage.setItem(storageKey, JSON.stringify(saved)); } catch {}
      refreshSaved();
    }));
    root.querySelector('[data-saved-open]').addEventListener('click', () => { refreshSaved(); dialog.showModal(); });
    root.querySelector('[data-saved-close]').addEventListener('click', () => dialog.close());
    refreshSaved();
  }
  document.querySelectorAll('[data-matrix-shop]').forEach(initMatrixShop);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-matrix-shop]').forEach(initMatrixShop));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matrix-space-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.space-art-video').forEach(video=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches){video.autoplay=false;video.pause();}else{new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)video.play().catch(()=>{});else video.pause();})).observe(video);}});

  document.addEventListener('click',event=>{const link=event.target.closest('[data-space-scroll]');if(!link)return;const target=document.getElementById('new-arrivals');if(!target)return;event.preventDefault();link.closest('details')?.removeAttribute('open');target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});target.focus({preventScroll:true});history.replaceState(null,'','#new-arrivals');});

  } catch(e) { console.error(e); }
})();
})();
